<template>
  <v-container class="py-10">
    <v-row>
      <v-col>
        <content-element
          v-for="rel in allRelations"
          :id="rel.data.id"
          :key="rel.data.id"
          :type="rel.data.type"
          :links="rel.data.links"
          :meta="meta"
          :attributes="rel.data.attributes"
          :relationships="rel.data.relationships"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import API_CONSTANTS from '@/js/helper/api-constants.js'

import { parseDataAttributeJson } from '@/js/helper/data-attribute-helper.js'
import { getAllRelations } from '@/js/helper/relationships-helper.js'

import ContentElement from './ContentElement/ContentElement.vue'

export default {
  name: 'PageContent',
  components: { ContentElement },
  props: {
    page: {
      type: String,
      default: '',
    },
  },
  data() {
    return parseDataAttributeJson(this.page, {
      fallbackId: API_CONSTANTS.PAGE,
      fallbackType: API_CONSTANTS.PAGE,
    })
  },
  computed: {
    allRelations() {
      return getAllRelations(this.relationships)
    },
  },
}
</script>
